import React from "react"
import styled, { keyframes } from "styled-components"

const skBounce = keyframes`
  0%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  }
  50% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
`

const skRotate = keyframes`
  100% {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
`

const Spinner = styled.div`
  margin: 100px auto;
  width: 50px;
  height: 50px;
  position: relative;
  text-align: center;

  -webkit-animation: ${skRotate} 2s infinite linear;
  animation: ${skRotate} 2s infinite linear;
`

const Dot1 = styled.div`
  width: 40%;
  height: 40%;
  display: inline-block;
  position: absolute;
  top: 0;
  border-radius: 100%;
  border: solid #c4c4c4 4px;

  -webkit-animation: ${skBounce} 2s infinite ease-in-out;
  animation: ${skBounce} 2s infinite ease-in-out;
`

const Dot2 = styled.div`
  width: 40%;
  height: 40%;
  display: inline-block;
  position: absolute;
  top: 0;
  border-radius: 100%;
  border: solid #c4c4c4 4px;

  -webkit-animation: ${skBounce} 2s infinite ease-in-out;
  animation: ${skBounce} 2s infinite ease-in-out;
  top: auto;
  bottom: 0;
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
`

const LoadingBubble = () => (
  <Spinner>
    <Dot1 />
    <Dot2 />
  </Spinner>
)

export default LoadingBubble



// WEBPACK FOOTER //
// ./src/components/loading-bubble/loading-bubble.component.js